import { render, staticRenderFns } from "./PlannedTransactionItem.vue?vue&type=template&id=f8cd8a16&scoped=true&"
import script from "./PlannedTransactionItem.vue?vue&type=script&lang=js&"
export * from "./PlannedTransactionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cd8a16",
  null
  
)

export default component.exports